/**
 * Where the learner is going when this page is left (owner 13 Oct: "when it is going back to home, then it should never
 * show loading bar showing quikbase image but correct info that is teleporting to Home"; the next-unit trip showed the
 * unit being left). Set just before a departure: {to: 'home'}, {to: 'quikbase'} or {to: 'unit', unitId, units}. The
 * loading screen names it instead of this page's own launch; the next page starts without one.
 */
let trip = null;
const listeners = new Set();

export function setLoadingTrip(next) {
  trip = next || null;
  listeners.forEach(listener => listener(trip));
}

export const loadingTrip = () => trip;

export function onLoadingTrip(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
